<template>
  <div class="image">
      <img :src="imgSrc" :alt="imgAlt" :width="imgWidth" :height="imgHeight">      
  </div>
</template>

<script>
export default {
  props: {
    imgSrc: {
      type: String,
      required: true
    },
    imgAlt: {
      type: String,
      required: true
    },
    imgWidth: {
      type: String,
      required: true
    },
    imgHeight: {
      type: String,
      required: true
    }
  }
}
</script>

<style>

  .image {
  width: 40%;
  }
</style>